import axios from "axios";
import {
  WithInterceptors,
  WithAuthenticationInterceptors,
} from "./ApiConnectorInterceptor";
import { getConfigurationBaseUrl } from "../utility/ConfigUtility";

export const PortalApiConnector = WithAuthenticationInterceptors(
  axios.create({
    baseURL: getConfigurationBaseUrl(),
  })
);

export const PortalApiPublicConnector = WithInterceptors(
  axios.create({ baseURL: getConfigurationBaseUrl() })
);

export const ApiConnector = (url:string) => {
  return WithInterceptors(axios.create({ baseURL: url }));
};

export const jsonContentConfig = {
  headers: {
    "Content-Type": "application/json",
  },
};
